const HOST_OR_DEFAULT_TO_PROD =
  import.meta.env.VITE_LINKPOP_API_HOST || 'linkpop.com';

export const LINKPOP_API_HOST = HOST_OR_DEFAULT_TO_PROD;
